
import { mutations } from '@/assets/scripts/store'

export default {
  name: 'DetailPortrait',

  head() {
    return this.popinData ? this.popinData.metaTags : null
  },

  computed: {
    popinData: mutations.getPopinData,

    isGuest() {
      return this.popinData.status === 'Guest'
    },
  },
}
